import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
//Vue.use(axios)
Vue.use(VueAxios, axios)
import VueKonva from 'vue-konva'
Vue.use(VueKonva)

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)
Vue.prototype.$store = store;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
